<template>
    <div id="image" v-if="enableDownload">
        <product-qr-ui :product="product" :qrCodeValue="qrCodeValue" :borders="false" :isPdf="true"/>
    </div>
</template>
<script>
import * as htmlToImage from 'html-to-image'
import ProductQrUi from '@/components/app-specific/ProductQrUi.vue'
import { mapActions } from 'vuex'
import { changeDpiDataUrl } from 'changedpi'
export default {
  components: {
    ProductQrUi
  },
  props: ['enableDownload', 'product', 'qrCodeValue'],
  methods: {
    async downloadImage() {
      let image = document.getElementById('image')
      await htmlToImage.toJpeg(image, { quality: 1 })
        .then(function(dataUrl) {
            const downloadLink = document.createElement('a');
            downloadLink.href = changeDpiDataUrl(dataUrl, 300);
            downloadLink.download = 'image.jpeg';
            downloadLink.click();
        })
      this.$emit('disable')
      this.setProductSelectionType('pdf')
    },
    ...mapActions({
      setProductSelectionType: 'locationproduct/setProductSelectionType'
    })
  },
  watch: {
    enableDownload: function(value) {
        if (value) {
            setTimeout(() => {
                this.downloadImage()
            }, 500);
        }
    }
  },
  mounted() {
  }
}
</script>
<style lang="scss">
#image {
  height: fit-content;
  width: fit-content
}
</style>
